import { Fragment, SetStateAction, useState } from 'react'
import { useParams } from 'react-router-dom'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import useEditDeleteModal from '../../../../../../utils/hooks/useEditDeleteModal'
import { OnSubmit } from '../../../../../../forms/TwinForm/types'
import { TableInstanceType } from '../../../../../../baseComponents/TwinTable/types'
import useUpdateTableInstance from '../../../../../../utils/hooks/useUpdateTableInstance'
import { CustomerModelType } from '@teinor/erp/types/company/customer'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import ModalCECustomerBank from '../../../CustomerBanks/ModalCECustomerBank'
import ModalDeleteCustomerBank from '../../../CustomerBanks/ModalDeleteCustomerBank'
import { CustomerDashboardAddButton, CustomerDashboardSeeAllLink } from '../../SpecificComponents'
import { getUserPermissions } from '../../../../../../utils/reducers/getters'
import { TableCustomerBanks } from '../../../CustomerBanks'

interface CustomerBanksDashboardProps extends CustomerBanksDashboardLogicProps {
    title: string
    allRowData: CustomerModelType
}

const CustomerBanksDashboard: React.FC<CustomerBanksDashboardProps> = ({ title, allRowData }) => {
    const { t } = useTwinTranslation()
    const { setTableInstance, tableInstance } = useCustomerBanksDashboardLogic()
    const { updateTableInstance } = useUpdateTableInstance({ tableInstance })
    const userPermissions = getUserPermissions('customer.profile.bank')
    return (
        <div className='flex flex-col flex-auto gap-10'>
            <div className='flex flex-wrap justify-between gap-5'>
                <div className='flex items-center gap-x-10'>
                    <h3>{title}</h3>
                    <CustomerDashboardSeeAllLink customerTab='bank' customerType={allRowData?.customer_type} />
                </div>
                <CustomerDashboardAddButton userPermissions={userPermissions || { n: 4, permission: 'delete' }} CreateModalComponent={ModalCECustomerBank} onSubmit={updateTableInstance} text={t('newBank', 'Nuevo banco')} />
            </div>
            <TableCustomerBanksDashboard userPermissions={userPermissions || { n: 4, permission: 'delete' }} onSubmit={updateTableInstance} setTableInstance={setTableInstance} tableInstance={tableInstance} />
        </div>
    )
}

interface CustomerBanksDashboardLogicProps { }

const useCustomerBanksDashboardLogic = () => {
    const [tableInstance, setTableInstance] = useState<TableInstanceType>(null)
    return { setTableInstance, tableInstance }
}

interface TableCustomerBanksDashboardProps extends ComponentWithPermissions {
    onSubmit: OnSubmit
    setTableInstance: React.Dispatch<SetStateAction<TableInstanceType>>
    tableInstance: TableInstanceType
}

const TableCustomerBanksDashboard: React.FC<TableCustomerBanksDashboardProps> = ({ onSubmit, setTableInstance, userPermissions, tableInstance }) => {
    const { id } = useParams()
    const { openModal, setOpenModal } = useEditDeleteModal()
    return (
        <Fragment>
            <TableCustomerBanks name='customerBanksDashboard' className='small_simple_table' hideLoadFiltersButton={true} extraWhereParams={{ CustomerId: id }} setTableInstance={setTableInstance} setOpened={setOpenModal} tableInstance={tableInstance} userPermissions={userPermissions} />
            {openModal?.type === 'edit' && <ModalCECustomerBank {...{ setOpened: () => setOpenModal(null) }} onSubmit={onSubmit} userPermissions={userPermissions} allRowData={openModal?.allRowData} basicData={{}} />}
            {openModal?.type === 'delete' && <ModalDeleteCustomerBank {...{ setOpened: () => setOpenModal(null) }} onSubmit={onSubmit} userPermissions={userPermissions} allRowData={openModal?.allRowData} basicData={{}} />}
        </Fragment>
    )
}

export default CustomerBanksDashboard